import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import {
    getReviewById,
    approveReview,
    hideReview,
    restoreReview,
    deleteReview,
} from "../services/adminApi";

import "../styles/ReviewDetails.css";

const ReviewDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [review, setReview] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadReview();
    }, []);

    const loadReview = async () => {
        try {
            const res = await getReviewById(id);
            setReview(res.data.review);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleApprove = async () => {
        await approveReview(id);
        loadReview();
    };

    const handleHide = async () => {
        await hideReview(id);
        loadReview();
    };

    const handleRestore = async () => {
        await restoreReview(id);
        loadReview();
    };

    const handleDelete = async () => {
        if (!window.confirm("Delete this review?")) return;

        await deleteReview(id);
        navigate("/admin/reviews");
    };

    if (loading) return <h2>Loading...</h2>;

    if (!review) return <h2>Review not found.</h2>;

    return (
        <div className="review-details">

            <div className="review-details-header">

                <h2>Review Details</h2>

                <button onClick={() => navigate(-1)}>
                    Back
                </button>

            </div>

            <div className="details-grid">

                <div className="detail-card">

                    <h3>Customer</h3>

                    <p><strong>Name:</strong> {review.customer?.name}</p>

                    <p><strong>Email:</strong> {review.customer?.email}</p>

                </div>

                <div className="detail-card">

                    <h3>Provider</h3>

                    <p><strong>Business:</strong> {review.provider?.businessName}</p>

                </div>

                <div className="detail-card">

                    <h3>Food</h3>

                    <p><strong>Name:</strong> {review.food?.foodName}</p>

                </div>

                <div className="detail-card">

                    <h3>Review</h3>

                    <p><strong>Rating:</strong> ⭐ {review.rating}</p>

                    <p>{review.comment}</p>

                </div>

                <div className="detail-card">

                    <h3>Status</h3>

                    <p>{review.status}</p>

                </div>

                <div className="detail-card">

                    <h3>Created</h3>

                    <p>
                        {new Date(review.createdAt).toLocaleString()}
                    </p>

                </div>

            </div>

            <div className="review-buttons">

                <button onClick={handleApprove}>
                    Approve
                </button>

                <button onClick={handleHide}>
                    Hide
                </button>

                <button onClick={handleRestore}>
                    Restore
                </button>

                <button onClick={handleDelete}>
                    Delete
                </button>

            </div>

        </div>
    );
};

export default ReviewDetails;